import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw = {
  name: 'auth',
  path: '/auth',
  component: () => import('#/auth/auth.view.vue'),
  redirect: '/auth/login',
  meta: { requiresLogin: false },
  children: [
    {
      name: 'auth:login',
      path: 'login',
      component: () => import('#/auth/login/login.view.vue'),
    },
    {
      name: 'auth:forgot-password',
      path: 'forgot-password',
      component: () => import('#/auth/forgot-password/forgot-password.view.vue'),
    },
    {
      name: 'auth:set-password',
      path: 'set-password',
      component: () => import('#/auth/set-password/set-password.view.vue'),
    },
    {
      name: 'auth:logout',
      path: 'logout',
      component: () => import('#/auth/logout/logout.view.vue'),
    },
    {
      path: ':pathMatch(.*)*',
      redirect: '/auth/login',
    },
  ],
};
